import { RiHome3Line } from 'react-icons/ri';
const HomeCustomIcon = () => <RiHome3Line size={20} />;

export default HomeCustomIcon;
